import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { style } from '../../utils/style.js';
const DAY_COUNT = 6;
const WEEK_COUNT = 7;
export const renderCalendarCells = ({ today, firstDayOfWeek, totalDays, currentMonth, currentYear, min, max, onDateClick, }) => {
    const calendarCells = [];
    let dayCounter = 1;
    for (let i = 0; i < DAY_COUNT; i++) {
        const rowCells = [];
        for (let j = 0; j < WEEK_COUNT; j++) {
            if (i === 0 && j < firstDayOfWeek) {
                rowCells.push(_jsx("td", {}, `empty-${j}`));
            }
            else if (dayCounter > totalDays) {
                rowCells.push(_jsx("td", {}, `empty-${j}`));
            }
            else {
                const currentDate = new Date(currentYear, currentMonth, dayCounter);
                const isToday = checkIsToday(currentDate, today);
                const isDisabled = checkIsDisabled(currentDate, min, max);
                rowCells.push(_jsx("td", { children: _jsx("div", { className: getDayStyles(isToday, isDisabled), onClick: () => !isDisabled && onDateClick(currentDate), children: dayCounter }) }, `day-${dayCounter}`));
                dayCounter++;
            }
        }
        calendarCells.push(_jsx("tr", { children: rowCells }, `row-${i}`));
    }
    return calendarCells;
};
const checkIsToday = (currentDate, today) => today && currentDate.toDateString() === today.toDateString();
const checkIsDisabled = (currentDate, min, max) => (min && currentDate.getTime() < min.getTime()) || (max && currentDate.getTime() > max.getTime());
const getDayStyles = (isToday, isDisabled) => style('p-s text-center rounded-md border', {
    'border-transparent hover:bg-gray': !isToday,
}, isDisabled ? 'text-gray hover:bg-transparent' : 'cursor-pointer');
//# sourceMappingURL=renderCalendarCells.js.map